import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import {
  selectSuggestionsLoading,
  selectDetailsLoading,
  selectTilesDetails,
  selectRestrictedDataError,
  selectMusicLoading,
  selectVideoTimerActive,
} from "../mainApp/features/DataSlice/dataSlice";
import "./App.css";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import Login from "./components/login";
import SignUp from "./components/register";
import ResetPassword from "./components/resetPassword";
import EmailVerification from "./components/EmailVerification";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Profile from "./components/profile";
import { auth, db } from "./components/firebase";
import { doc, getDoc, updateDoc } from "firebase/firestore";
import Home from "./components/home";
import { GlobalStyleAi } from "../../GlobalStyle";
import Reels from "./components/Bots/Reels/Chatbot.js";
import Lawyer from "./components/Bots/Lawyer/Chatbot.js";
import Sprawdzam from "./components/sprawdzam";
import apps from "./components/Utility/apps.json";
import { ThemeProvider } from "styled-components";
import { aiTheme } from "../../../src/theme.js";
import { Container } from "./components/Utility/Container/styled.js";
import NavigationBar from "./components/Navigation/index.js";
import Navbar from "../aiApp/components/Navigation/NavigationMobile/Navbar.js";
import LeftNavigationBar from "./components/Navigation/LeftNavigationBar.js";
import useWindowDimensions from "../mainApp/features/Hooks/useWindowDimensions.js";
import BackButton from "./components/Navigation/NavigationMobile/BackButton.js";
import VideoCreator from "./components/Bots/VideoCreator/Chatbot.js";
import Hal from "./components/TechnicalTabs/NoResult/index.js";
import ChatbotHistory from "./components/ChatHistory/ChatbotHistory.js";
import ProfilePage from "./components/ProfilePage/ProfilePage.js";
import Pricing from "./components/Pricing/PricingPlans.js";
import { handleUnauthorizedAccess as Unauthorized } from "./components/Utility/handleUnauthorizedAccess.js";
import ChatbotCasual from "./components/Bots/Casual/Chatbot.js";
import PrivacyPolicy from "./components/TechnicalTabs/PrivacyPolicy/index.js";
import Regulations from "./components/TechnicalTabs/Regulations/index.js";
import UnderConstruction from "./components/TechnicalTabs/UnderConstruction/index.js";
import InfoHub from "./components/TechnicalTabs/InfoHub/index.js";
import CookieBar from "./components/TechnicalTabs/CookieBar/index.js";
import FacebookChatbot from "./components/Bots/FacebookPost/Chatbot.js";
import ImageChatbot from "./components/Bots/ImageCreator/Chatbot.js";
import AdvancedChatbot from "./components/Bots/SocialMedia/Chatbot.js"
import ArticlesChatbot from "./components/Bots/Articles/Chatbot.js";
import Advertisement from "./components/Bots/Advertisement/Chatbot.js";
import { Crisp } from "crisp-sdk-web";
import MusicCreator from "./components/Bots/MusicCreator/Chatbot.js";
import DietAdvisor from "./components/Bots/DietAdvisor/Chatbot.js";
import SearchEngine from "./components/Bots/SearchEngine/Chatbot.js";
import Settings from "./components/SettingsBar/Settings/index.js";
import Help from "./components/SettingsBar/Help/index.js";
import Tokens from "./components/SettingsBar/Tokens/index.js";
import { NoResultContainer, StyledH1, Hal as UnderHal } from "./components/TechnicalTabs/UnderConstruction/styled.js";
import builderImg from "./components/Assets/budowlaniec.png";
import TermsOfServiceModal from "./components/TechnicalTabs/TermsOfServiceModal";
import AgeVerificationModal from "./components/TechnicalTabs/AgeVerificationModal";
import {
  CloseButton,
  ShowChatButton,
} from "./components/CrispManager/styled";

const SvgDefs = () => (
  <svg width="0" height="0" style={{ position: 'absolute', zIndex: -1 }}>
    <defs>
      <linearGradient id="premium-icon-gradient" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" style={{ stopColor: '#ffdb4d' }} />
        <stop offset="100%" style={{ stopColor: '#ff8c00' }} />
      </linearGradient>
    </defs>
  </svg>
);

function App() {
  const suggestionsLoading = useSelector(selectSuggestionsLoading);
  const detailsLoading = useSelector(selectDetailsLoading);
  const musicLoading = useSelector(selectMusicLoading);
  const videoGenerating = useSelector(selectVideoTimerActive);
  const tilesDetails = useSelector(selectTilesDetails);
  const restrictedDataError = useSelector(selectRestrictedDataError);
  const isLoading = suggestionsLoading || detailsLoading || musicLoading || videoGenerating;
  const [user, setUser] = useState();
  const [userDetails, setUserDetails] = useState(null);
  const [showTermsModal, setShowTermsModal] = useState(false);
  const [showAgeVerificationModal, setShowAgeVerificationModal] = useState(false);
  const [crispInitialized, setCrispInitialized] = useState(false);
  const [isUserDismissed, setIsUserDismissed] = useState(false);
  const location = useLocation();

  // Lista ścieżek, gdzie czat Crisp NIE ma być widoczny
  const chatHiddenPaths = [
    "/404",
    "/unauthorized",
    "/profile",
    "/register",
    "/login",
    "/reset-password",
    "/email-verification",
    ...(tilesDetails.length === 0 && restrictedDataError || !userDetails
      ? ["/pricing"]
      : []),
    ...(tilesDetails.length === 0 && restrictedDataError || !userDetails
      ? ["/home"]
      : []),
    ...(tilesDetails.length === 0 && restrictedDataError || !userDetails
      ? ["/profilePage"]
      : []),
        ...(tilesDetails.length === 0 && restrictedDataError || !user || !userDetails ? ["/policy"] : []),
    ...(tilesDetails.length === 0 && restrictedDataError || !user || !userDetails ? ["/regulations"] : []),
     ...(tilesDetails.length === 0 && restrictedDataError || !user || !userDetails ? ["/info"] : []),
  ];

  // Inicjalizacja Crisp - tylko raz
  useEffect(() => {
    if (!crispInitialized) {
      Crisp.configure(process.env.REACT_APP_CRISP_KEY, {
        autoload: false // ✅ Wyłącz autoload
      });
      setCrispInitialized(true);
     
    }
  }, []);
  // Pobieranie userDetails z Firebase i obsługa sesji Crisp
  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged(async (currentUser) => {
      if (currentUser) {
        // ✅ Ustaw token PRZED załadowaniem Crisp
        if (crispInitialized) {
          Crisp.setTokenId(currentUser.uid);
          Crisp.session.reset(); 
          Crisp.load(); // ✅ Załaduj Crisp z tokenem
         
        }

        setUser(currentUser);
        try {
          const docRef = doc(db, "Users", currentUser.uid);
          const docSnap = await getDoc(docRef);
          if (docSnap.exists()) {
            setUserDetails(docSnap.data());
          } else {
            console.warn("Dokument użytkownika nie istnieje.");
            setUserDetails({
              email: currentUser.email,
              firstName: "",
              photo: "",
            });
          }
        } catch (error) {
          console.error("Błąd pobierania userDetails:", error);
          setUserDetails(null);
        }
      } else {
        // ✅ TYLKO unbind lokalną sesję przy wylogowaniu
        if (crispInitialized && window.CRISP_WEBSITE_ID) {
          Crisp.setTokenId(); // Wyczyść token lokalnie
          Crisp.session.reset(); // Reset lokalnej sesji (NIE niszczy sesji na serwerze)
         
        }
        setUser(null);
        setUserDetails(null);
      }
    });
    return () => unsubscribe();
  }, [crispInitialized]);

  // Ustawianie danych użytkownika w Crisp
  useEffect(() => {
    if (crispInitialized && user && userDetails) {
      Crisp.user.setEmail(userDetails.email || "N/A");
      Crisp.user.setNickname(userDetails.firstName || "User");
      Crisp.session.setData({ user_id: user.uid });
    }
  }, [user, userDetails, crispInitialized]);


useEffect(() => {
  if (!crispInitialized) return;
  
  // Jeśli user = null I jesteśmy na /login - wymusza ukrycie
  if (!user && location.pathname === "/login") {
    Crisp.chat.hide();
   
  }
}, [user, location.pathname, crispInitialized]);

useEffect(() => {
  if (userDetails) {
    if (userDetails.termsAccepted === false) {
      setShowTermsModal(true);
    } else if (userDetails.termsAccepted === true && userDetails.ageVerified !== true) {
      // Jeśli regulamin zaakceptowany, ale wiek nie zweryfikowany
      setShowAgeVerificationModal(true);
    }
  }
}, [userDetails]);

const handleAcceptTerms = async () => {
  if (user) {
    const userRef = doc(db, "Users", user.uid);
    await updateDoc(userRef, {
      termsAccepted: true,
    });
    setUserDetails((prevDetails) => ({ ...prevDetails, termsAccepted: true }));
    setShowTermsModal(false);
    // useEffect automatycznie pokaże okno weryfikacji wieku po aktualizacji userDetails
  }
};

const handleAcceptAge = async () => {
  if (user) {
    const userRef = doc(db, "Users", user.uid);
    await updateDoc(userRef, {
      ageVerified: true,
    });
    setUserDetails((prevDetails) => ({ ...prevDetails, ageVerified: true }));
    setShowAgeVerificationModal(false);
  }
};

const handleDeclineAge = async () => {
  if (user) {
    // Wyloguj użytkownika, jeśli nie ma 18 lat
    await auth.signOut();
    setShowAgeVerificationModal(false);
  }
};

  // Kontrola widoczności widgetu Crisp
  useEffect(() => {
    if (!crispInitialized) return;

    const shouldShowChatOnPath = !chatHiddenPaths.includes(location.pathname);

    if (shouldShowChatOnPath) {
      if (isUserDismissed) {
        Crisp.chat.hide();
      } else {
        Crisp.chat.show();
      }
    } else {
      Crisp.chat.hide();
      setIsUserDismissed(false);
    }
  }, [
    location.pathname,
    chatHiddenPaths,
    crispInitialized,
    isUserDismissed,
  ]);

  const handleDismiss = () => {
    setIsUserDismissed(true);
  };

  const handleShow = () => {
    setIsUserDismissed(false);
  };

  const dimensions = useWindowDimensions();
  let navigationBar;
  if (dimensions.width < 970) {
    navigationBar = <Navbar isDupa />;
  } else {
    navigationBar = <NavigationBar isLoading={isLoading} />;
  }

  return (
    <ThemeProvider theme={aiTheme}>
      <SvgDefs />
      <GlobalStyleAi currentPath={location.pathname} />
      <TermsOfServiceModal show={showTermsModal} onAccept={handleAcceptTerms} />
      <AgeVerificationModal 
        show={showAgeVerificationModal} 
        onAccept={handleAcceptAge}
        onDecline={handleDeclineAge}
      />
      
      {(() => {
        const shouldShowChatOnPath = !chatHiddenPaths.includes(location.pathname);
        if (!shouldShowChatOnPath) return null;

        return isUserDismissed ? (
          <ShowChatButton onClick={handleShow}>
            <span>↑</span>
            <span>Pokaż czat</span>
          </ShowChatButton>
        ) : (
          <CloseButton onClick={handleDismiss}>—</CloseButton>
        );
      })()}

      {(() => {
        const baseHidden = [
          "/404",
          "/unauthorized",
          "/profile",
          "/register",
          "/login",
          "/reset-password",
          "/email-verification",
          "/info"
        ];
        const gating = (tilesDetails.length === 0 && restrictedDataError) || !userDetails;
        const conditionalHidden = [
          ...(gating ? ["/pricing"] : []),
          ...(gating ? ["/policy"] : []),
          ...(gating ? ["/regulations"] : []),
        ];
        const overlayHiddenPaths = [...baseHidden, ...conditionalHidden];
        const showOverlay = dimensions.width < 970 && !overlayHiddenPaths.includes(location.pathname);
        if (!showOverlay) return null;
        return (
          <div
            style={{
              position: "fixed",
              inset: 0,
              background: "#0b0b0b",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              zIndex: 2147483647,
              padding: "24px",
            }}
          >
            <div style={{ maxWidth: 560, textAlign: "center" }}>
                <StyledH1>Pracujemy w pocie czoła!</StyledH1>
              <StyledH1>Wersja mobilna już wkrótce!</StyledH1>
              <br/>
              <UnderHal src={builderImg} alt="Wersja mobilna w budowie" />
              <NoResultContainer>
                <br/>
                <StyledH1>
                     Dla większej wygody, skorzystaj z szerszego ekranu.
                  <br />
                     Użyj tableta lub komputera.
                </StyledH1>
              </NoResultContainer>
            </div>
          </div>
        );
      })()}
      {navigationBar}
      <LeftNavigationBar isLoading={isLoading} />
      <Container currentPath={location.pathname} isModalOpen={showTermsModal}>
        <Routes>
          <Route
            path="/"
            element={
              user ? (
                <Navigate to="/profile" />
              ) : (
                <Navigate to="/login" />
              )
            }
          />
          <Route path="/login" element={<Login />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/register" element={<SignUp />} />
          <Route path="/email-verification" element={<EmailVerification />} />
          <Route path="/profile" element={<Profile />} />
          <Route
            path="/reels"
            element={
              <>
                <BackButton />
                <Reels />
              </>
            }
          />
          <Route
            path="/lawyer"
            element={
              <>
                <BackButton />
                <Lawyer />
              </>
            }
          />
          <Route
            path="/casual"
            element={
              <>
                <BackButton />
                <ChatbotCasual />
              </>
            }
          />
              <Route
            path="/facebook"
            element={
              <>
                <BackButton />
                <FacebookChatbot />
              </>
            }
          />
            <Route
            path="/image"
            element={
              <>
                <BackButton />
                <ImageChatbot />
              </>
            }
          />
             <Route
            path="/socialmedia"
            element={
              <>
                <BackButton />
                <AdvancedChatbot />
              </>
            }
          />
          <Route
            path="/articles"
            element={
              <>
                <BackButton />
                <ArticlesChatbot />
              </>
            }
          />
              <Route
            path="/advertisement"
            element={
              <>
                <BackButton />
                <Advertisement />
              </>
            }
          />
           <Route
            path="/music"
            element={
              <>
                <BackButton />
                <MusicCreator />
              </>
            }
          />
           <Route
            path="/diet"
            element={
              <>
                <BackButton />
                <DietAdvisor />
              </>
            }
          />
          <Route
            path="/search"
            element={
              <>
                <BackButton />
                <SearchEngine />
              </>
            }
          />
          <Route path="/sprawdzam" element={<Sprawdzam />} />
          <Route path="/unauthorized" element={<Unauthorized />} />
          <Route path="/videocreator" element={<VideoCreator />} />
          <Route path="/home" element={<Home selectedCast={apps} />} />
          <Route path="/hal" element={<Hal />} />
          <Route path="/chatbot-history" element={<ChatbotHistory />} />
          <Route path="/profilePage" element={<ProfilePage />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/settings/*" element={<Settings />} />
          <Route path="/help/*" element={<Help />} />
          <Route path="/info" element={<InfoHub />} />
          <Route path="/tokens/*" element={<Tokens />} />
          <Route
            path="/regulations"
            element={
              <>
                <BackButton />
                <Regulations />
              </>
            }
          />
          <Route
            path="/policy"
            element={
              <>
                <BackButton />
                <PrivacyPolicy />
              </>
            }
          />
          <Route path="/404" element={<><BackButton is404/><Hal /></>} />
          <Route path="/construction" element={<UnderConstruction />} />
          <Route path="/construction1" element={<UnderConstruction />} />
          <Route path="*" element={<Navigate to="/404" />} />
        </Routes>
        <ToastContainer />
      </Container>
      <CookieBar />
    </ThemeProvider>
  );
}

export default App;